import { render } from "./StockReservado.vue?vue&type=template&id=94a7ebc4"
import script from "./StockReservado.vue?vue&type=script&lang=js"
export * from "./StockReservado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__